import { render, staticRenderFns } from "./textLoad.vue?vue&type=template&id=515c63e6&scoped=true"
import script from "./textLoad.vue?vue&type=script&lang=js"
export * from "./textLoad.vue?vue&type=script&lang=js"
import style0 from "./textLoad.vue?vue&type=style&index=0&id=515c63e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515c63e6",
  null
  
)

export default component.exports